<template>
  <div id="participants-container">
    <div class="in-conversation">
      <div class="in-conversation-header">
        <div class="participants-title">Participants in this conversation</div>
      </div>
      <div @click="changeParticipantsState()">
        <img
          class="close"
          src="../assets/close.png"
          alt="close participant overview"
        />
      </div>
      <div class="in-conversation-body">
        <SpeakerBioCard />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SpeakerBioCard from "../components/SpeakerBioCard.vue";
export default {
  name: "Participants",
  components: {
    SpeakerBioCard,
  },
  computed: { ...mapState(["device_mode"]) },
  mounted() {
    const participantContainer = document.getElementById(
      "participants-container"
    );
    if (this.device_mode == "mobile") {
      participantContainer.style.width = "100%";
      participantContainer.style.height = "90vh";
    } else {
      participantContainer.style.width = "375px";
      participantContainer.style.height = "593px";
    }
  },
  watch: {
    device_mode: function (device_mode) {
      const participantContainer = document.getElementById(
        "participants-container"
      );
      if (device_mode == "mobile") {
        participantContainer.style.width = "100%";
        participantContainer.style.height = "90vh";
      } else {
        participantContainer.style.width = "375px";
        participantContainer.style.height = "593px";
      }
    },
  },
  methods: {
    changeParticipantsState() {
      this.$store.commit("toggleParticipants");
    },
  },
};
</script>

<style scoped>
#participants-container {
  z-index: 1;
  position: fixed;
  overflow-y: scroll;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  background-color: rgba(44, 44, 46, 0.3);
  margin-right: 0px;
  font-size: 16px;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
#participants-container::-webkit-scrollbar {
  display: none;
}

.close {
  width: 30px;
  position: absolute;
  top: 25px;
  right: 30px;
}

.close:hover {
  cursor: pointer;
}

.in-conversation {
  padding-bottom: 30px;
}

.in-conversation-header {
  padding-top: 10px;
  padding-left: 42px;
  font-size: 16px;
  font-weight: 700;
}

.episode-title {
  font-weight: 500;
}

.participants-title {
  margin-top: 20px;
}

.in-conversation-body {
  margin-top: 25px;
  margin-left: 30px;
  margin-right: 30px;
  border-top: 1px solid rgba(72, 72, 74, 1);
}
</style>